package ai.wagemix.data.firebase

import ai.wagemix.data.WMUnauthenticatedException
import com.fsryan.foundation.net.client.FSAuthorizationContext
import com.fsryan.foundation.net.client.FSAuthorizedRequester
import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.FirebaseUser
import kotlinx.coroutines.flow.first

/**
 * Firebase Authentication as the API client's [FSAuthorizedRequester]: the signed-in user's id
 * token is the bearer token of every authenticated API call, and a call made with nobody signed
 * in fails with [WMUnauthenticatedException] wrapped in the foundation's token-fetch failure.
 */
fun WMFirebaseAuthorizedRequester(auth: FirebaseAuth, apiBaseUrl: String): FSAuthorizedRequester = FSAuthorizedRequester(
    fetchAuthorizationContext = { FSAuthorizationContext(authServerURL = apiBaseUrl, userId = auth.restoredUser()?.uid ?: "") },
    fetchAccessToken = { auth.restoredUser()?.getIdToken(false) ?: throw WMUnauthenticatedException() }
)

/**
 * The signed-in user once Firebase has restored the persisted session. On a fresh page load (the
 * Stripe return, a deep link) [FirebaseAuth.currentUser] is `null` until that restore finishes;
 * the first [FirebaseAuth.authStateChanged] emission is the restored state, signed in or not.
 */
private suspend fun FirebaseAuth.restoredUser(): FirebaseUser? {
    return currentUser ?: authStateChanged.first()
}
